// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import type { ChannelScope } from 'features/channels/models';
import type { GroupDetailScope, GroupScope } from 'features/groups';
import type { MemberEntityScope } from 'features/users';

export const routes = {
  admin: {
    index: '/admin',
  },
  calendar: {
    index: '/calendar',
  },
  /**
   * @deprecated
   * Should be removed in December 2025- serves for backward compatibility with campaigns.
   */
  campaign: {
    detail: (organizationId: string, campaignId: string) => `/campaigns/listing/${organizationId}/${campaignId}`,
  },
  channels: {
    customChannelDetail: (id: string) => `/channels/${id}`,
    index: '/channels',
    organizationChannel: (organizationId: string, scope: ChannelScope) => `/channels/${organizationId}/${scope}`,
  },
  chat: {
    chatroom: (id: string) => `/messages/chatrooms/${id}`,
    create: '/messages/create',
    index: '/messages',
  },
  community: {
    assets: (id: string) => `/communities/${id}/assets`,
    feed: (id: string) => `/communities/${id}/feed`,
    index: '/communities',
    /**
     * @deprecated
     * Remove in version 2.15.0+ with backward redirect
     */
    indexRedirect: '/joined-communities',
    new: {
      about: (id: string) => `/communities/${id}/new/about`,
      assets: (id: string) => `/communities/${id}/new/assets`,
      feed: (id: string) => `/communities/${id}/new/feed`,
    },
    // TODO: solve query params
    shareInvite: (id: string, invitationToken: string) => `/communities/${id}?invitation_token=${invitationToken}`,
  },
  consents: '/consents',
  // TODO rearange routes to better fit the structure
  contentObjects: {
    activities(id: string) {
      return `/activities/${id}`;
    },
    events(id: string) {
      return `/events/${id}`;
    },
    kudos(id: string) {
      return `/kudos/${id}`;
    },
    polls(id: string) {
      return `/polls/${id}`;
    },
    posts(id: string) {
      return `/posts/${id}`;
    },
    videos(id: string) {
      return `/videos/${id}`;
    },
    withingsOrderPosts(id: string) {
      return `/withings_order_posts/${id}`;
    },
  },
  events: {
    /**
     * @deprecated
     * Remove in version 2.18.0+ with backward redirect
     */
    attendeesRedirect: (eventId: string) => `/events/${eventId}/attendees`,
    comments: (eventId: string, commentId?: string, replyId?: string) =>
      // eslint-disable-next-line sonarjs/no-nested-template-literals -- TODO: fix
      `/events/${eventId}/comments${commentId ? `/${commentId}` : ''}${replyId ? `/${replyId}` : ''}`,
    detail: (eventId: string) => `/events/${eventId}`,
    /**
     * @deprecated
     * Remove in version 3.2.0.
     */
    index: '/events',
    share: (eventId: string, invitationToken: string) => `/events/${eventId}/enter/${invitationToken}`,
  },
  giving: {
    browse: '/givings/browse',
    detail: (givingId: string) => `/givings/${givingId}`,
    index: '/givings',
    now: '/givings/now',
  },
  group: {
    detail: {
      /**
       * Dont remove this route, it serves as redirect for mail link send from BE
       * */
      index: (groupId: string) => `/groups/${groupId}`,
      scope: (groupId: string, scope: GroupDetailScope = 'announcements') => `/groups/${groupId}/${scope}`,
    },
    entities: (groupId: string, scope: ':scope' | GroupScope) => `/groups/${groupId}/entities/${scope}`,
    index: '/groups',
  },
  index: '/',
  login: {
    code: '/login/code',
    index: '/login',
    token: '/login/token',
  },
  members: {
    detail: (id: string) => `/members/${id}`,
    entities: (memberId: string, scope: MemberEntityScope) => `/members/${memberId}/entities/${scope}`,
    message: (id: string) => `/members/${id}/message`,
  },
  messages: '/messages',
  notifications: '/notifications',
  onboardingTour: {
    index: '/profile/onboarding',
  },
  organization: {
    /**
     * @deprecated
     * Remove in version 2.15.0+ with backward redirect
     */
    about: (id: string) => `/organizations/${id}/about`,
    detail: (id: string) => `/organizations/${id}`,
    entities: (organizationId: string, scope: 'communities' | 'givings' | 'programs' | 'videos') =>
      `/organizations/${organizationId}/${scope}`,
    index: '/organizations',
  },
  privacyPolicy: '/privacy-policy',
  /**
   * @deprecated
   * These are old routes for profile, but they are still used by mobile app and backend
   * */
  profile: {
    changePassword: '/profile/change-password',
    language: '/profile/language',
    personalInfo: '/profile/personal-info',
    removeAccount: '/profile/remove-account',
    settings: {
      notifications: '/profile/settings/notifications',
      translations: '/profile/settings/translations',
    },
  },
  program: {
    about(id: string) {
      return `/courses/${id}/about`;
    },
    assets: (id: string) => `/courses/${id}/assets`,
    detail: (id: string) => `/programs/${id}`,
    /**
     * @deprecated
     * We would like to use /programs, but we need to keep this backport because BE still use it
     */
    detailDeprecated: (id: string) => `/courses/${id}`,
    index: '/programs',
    /**
     * @deprecated
     * This is because legacy routes, that can be used on BE or in email / notification links
     * We can't easily remove this
     */
    indexAlias: '/courses',
    /**
     * @deprecated
     * Remove in version 2.15.0+ with backward redirect
     */
    indexRedirect: '/joined-programs',
    members: (id: string) => `/courses/${id}/members`,
    timeline(id: string) {
      return `/courses/${id}/timeline`;
    },
  },
  search: {
    results: (scope: string, query?: string) =>
      // eslint-disable-next-line sonarjs/no-nested-template-literals -- TODO: fix
      `/search/${scope}${query ? `?query=${encodeURIComponent(query)}` : ''}`,
  },
  settings: {
    index: '/settings',
  },
  signUp: '/sign-up',
  tokenLogin: '/token-login',
  user: {
    help: '/help',
    /**
     * @deprecated
     * This is old route for profile, but it can be still used by mobile app and backend
     * */
    profile: '/profile',
    settings: '/settings',
  },
  video: {
    detail: (id: string) => `/videos/${id}`,
    index: '/videos',
  },
} as const;
